exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".char-limit {\n    margin-right:0 !important;\n    font-size: 12px;\n    font-style: italic;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/sms-public-url/sms-public-url.component.css
// module id = ../../../../../src/app/mnt-invoices/sms-public-url/sms-public-url.component.css
// module chunks = common